import * as React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  ariaTitle: PropTypes.string
};

/**
 * Component that renders the Credera logo
 * Generated using SVGR CLI -> https://react-svgr.com/docs/cli/
 *
 * @component
 * @param {object} props
 */
const svgCrederaLogo = props => {
  const { ariaTitle = 'Credera Logo' } = props;

  return (
    <svg width={33} height={33} aria-labelledby="credera-logo-title">
      <title id="credera-logo-title">{ariaTitle}</title>
      <g fill="none" fillRule="evenodd">
        <path fill="#CFCFCF" fillRule="nonzero" d="M24 24h9v9h-9z" />
        <path fill="#E26751" fillRule="nonzero" d="M0 0h33v21h-9V9H9v15h12v9H0z" />
        <path d="M0 0h33v33H0z" />
      </g>
    </svg>
  );
};

svgCrederaLogo.propTypes = propTypes;

export default svgCrederaLogo;
